<ion-card>
  <ion-card-header>
    <ion-card-title>KRÉTA e-Ügyintézés – igazolások átemelése</ion-card-title>
    <ion-card-subtitle>
      Az EESZT-ből és a szülőktől érkező igazolás-kérelmek átvétele, és átvezetésük a naplóra
    </ion-card-subtitle>
  </ion-card-header>

  <ion-card-content>
    <div *ngIf="toltodik"><ion-spinner name="dots"></ion-spinner> Betöltés…</div>
    <div class="ke-hiba" *ngIf="hiba">{{ hiba }}</div>

    <ng-container *ngIf="!toltodik">
      <p class="ke-lead">
        A szülő – vagy az orvos az <b>EESZT</b>-en keresztül – a KRÉTA e-Ügyintézésben adja be a
        hiányzás igazolását. A rendszer ezeket átveszi, és a <b>lezárt, elfogadott</b> igazolásokat
        átvezeti a naplóra: az érintett napok óráin a tanuló hiányzása igazolttá válik, a KRÉTA-beli
        típussal és ügyiratszámmal.
      </p>

      <h3 class="ke-cim">Kapcsolat</h3>

      <!--  MÁR FELVETT FIÓK ÚJRAHASZNÁLÁSA. A naplózáshoz a kollégák belépései már be
            vannak állítva; ha az ügyintézői fiók köztük van, a jelszót nem kell újra
            begépelni – és nem is másoljuk át, mindig az eredeti sorból olvassuk. -->
      <div class="ke-racs" *ngIf="fiokok.length">
        <ion-item>
          <ion-label position="stacked">Már felvett KRÉTA-fiók használata</ion-label>
          <ion-select [(ngModel)]="b.forras_allomany" interface="popover"
                      placeholder="– új belépés megadása alább –">
            <ion-select-option [value]="''">– új belépés megadása alább –</ion-select-option>
            <ion-select-option *ngFor="let f of fiokok" [value]="f.allomany">
              {{ f.tanar_nev || f.allomany }} ({{ f.kreta_user }}){{ f.van_jelszo ? '' : ' – nincs jelszava' }}
            </ion-select-option>
          </ion-select>
        </ion-item>
      </div>
      <ion-note color="medium" class="ke-megj" *ngIf="valasztottFiok">
        A belépés <b>{{ valasztottFiok.tanar_nev || valasztottFiok.allomany }}</b> fiókjával történik
        (<code>{{ valasztottFiok.kreta_user }}</code>) — az alábbi felhasználónév és jelszó ilyenkor
        <b>nincs használatban</b>. A jelszót nem másoljuk át: ha a KRÉTA naplózásnál megváltoztatod,
        ez is követi.
      </ion-note>

      <div class="ke-racs">
        <!--  KÉT KÜLÖN CÍM VAN, ÉS EZ FÉLREÉRTHETŐ VOLT.
              A BELÉPÉS az iskola saját KRÉTÁ-jába megy (<iskola>.e-kreta.hu) – ez
              intézményenként más. Maga az e-Ügyintézés viszont KÖZPONTI szolgáltatás,
              mindenkinek ugyanazon a címen; azt nem kell (és nem is lehet) beállítani. -->
        <ion-item>
          <ion-label position="stacked">Iskolai KRÉTA cím a belépéshez (elhagyható)</ion-label>
          <ion-input [(ngModel)]="b.kreta_host" placeholder="pl. zenit vagy https://zenit.e-kreta.hu"></ion-input>
        </ion-item>
        <ion-item>
          <ion-label position="stacked">Ügyintézői felhasználónév</ion-label>
          <ion-input [(ngModel)]="b.kreta_user" autocomplete="off"></ion-input>
        </ion-item>
        <ion-item>
          <ion-label position="stacked">Jelszó {{ b.jelszo_beallitva ? '(be van állítva)' : '' }}</ion-label>
          <ion-input type="password" [(ngModel)]="jelszo" autocomplete="new-password"
                     placeholder="{{ b.jelszo_beallitva ? 'változatlanul hagyom' : 'jelszó' }}"></ion-input>
        </ion-item>
        <ion-item>
          <ion-label position="stacked">2FA titok (TOTP, ha van) {{ b.totp_beallitva ? '– be van állítva' : '' }}</ion-label>
          <ion-input [(ngModel)]="totp" autocomplete="off"
                     placeholder="{{ b.totp_beallitva ? 'változatlanul hagyom' : 'base32 titok' }}"></ion-input>
        </ion-item>
      </div>
      <ion-note color="medium" class="ke-megj">
        Az <b>e-Ügyintézés felülete központi</b> (<code>eugyintezes.e-kreta.hu</code>), mindenkinek
        ugyanaz — azt nem kell beállítani. A fenti cím a <b>belépéshez</b> kell: az iskola saját
        KRÉTÁ-ja, ahol a felhasználónév és jelszó érvényes. Üresen hagyva azt használjuk, ami a
        KRÉTA naplózásnál már be van állítva.
      </ion-note>
      <ion-note color="medium" class="ke-megj">
        <b>Egy fiók kell hozzá</b>, az intézmény ügyintézőjéé – nem tanáronkénti művelet. A jelszót
        titkosítva tároljuk, és a képernyő <b>soha nem adja vissza</b>: üresen hagyva marad a korábbi.
      </ion-note>

      <h3 class="ke-cim">Ütemezés</h3>
      <div class="ke-racs">
        <ion-item>
          <ion-label>Automatikus átemelés</ion-label>
          <!--  CSAK [checked] + (ionChange): az ngModel-lel együtt a kettő egymásnak
                feszülne (az egyik logikai értéket ír, a másik 0/1-et). -->
          <ion-toggle slot="end" [checked]="!!b.enabled"
                      (ionChange)="b.enabled = $event.detail.checked ? 1 : 0"></ion-toggle>
        </ion-item>
        <ion-item>
          <ion-label position="stacked">Milyen gyakran</ion-label>
          <ion-select [(ngModel)]="b.intervallum_perc" interface="popover">
            <ion-select-option [value]="60">óránként</ion-select-option>
            <ion-select-option [value]="180">3 óránként</ion-select-option>
            <ion-select-option [value]="360">6 óránként</ion-select-option>
            <ion-select-option [value]="720">naponta kétszer</ion-select-option>
            <ion-select-option [value]="1440">naponta egyszer</ion-select-option>
            <ion-select-option [value]="4320">3 naponta</ion-select-option>
          </ion-select>
        </ion-item>
        <ion-item>
          <ion-label position="stacked">Meddig nézünk vissza (nap)</ion-label>
          <ion-input type="number" [(ngModel)]="b.napok_vissza"></ion-input>
        </ion-item>
      </div>

      <div class="ke-racs">
        <ion-item>
          <ion-label>Szülői kérelemnél csak a döntéssel elfogadottat vezesse át</ion-label>
          <ion-toggle slot="end" [checked]="!!b.csak_elfogadott"
                      (ionChange)="b.csak_elfogadott = $event.detail.checked ? 1 : 0"></ion-toggle>
        </ion-item>
        <ion-item>
          <ion-label>Csak az EESZT-ből érkezett kérelmek</ion-label>
          <ion-toggle slot="end" [checked]="!!b.csak_eeszt"
                      (ionChange)="b.csak_eeszt = $event.detail.checked ? 1 : 0"></ion-toggle>
        </ion-item>
      </div>
      <!--  Az EESZT-igazolást orvos állítja ki, és az iskola az e-Ügyintézésben nem fogadja el:
            ott „Új" státuszban, döntés nélkül marad. Ha itt is elfogadást várnánk, egyetlen
            EESZT-igazolás sem jutna a naplóba – ezért a döntés-feltétel csak a szülőire vonatkozik. -->
      <ion-note color="medium" class="ke-megj">
        Az <b>EESZT-ből érkezett</b> orvosi igazolás döntés nélkül is átkerül a naplóba (azokat az
        iskola az e-Ügyintézés felületén nem fogadja el), és <b>a teljes napra szól</b>: a tanuló
        aznapi összes óráján hiányzó és igazolt lesz, akkor is, ha a tanár még nem írta be a
        hiányzást. Ha az igazolás valójában csak pár órára szól, az <b>osztályfőnök javítja</b> – a
        javítását a későbbi átemelések nem írják felül. A hiányzásba nem számító foglalkozásokat
        (pl. napközi) nem érinti.<br>
        A <b>szülői</b> kérelemnél a fenti kapcsoló dönt, és ott csak azokra az órákra kerül igazolás,
        ahol a tanár már bevezette a hiányzást. A kifejezetten <b>elutasított</b> kérelmet semmilyen
        forrásból nem vezetjük át.
      </ion-note>

      <div class="ke-gombok">
        <ion-button size="small" [disabled]="ment" (click)="mentes()">
          <ion-icon slot="start" name="save-outline"></ion-icon>Mentés
        </ion-button>
        <ion-button size="small" fill="outline" color="medium" [disabled]="tesztFut" (click)="teszt()">
          <ion-icon slot="start" name="flask-outline"></ion-icon>
          {{ tesztFut ? 'Belépés…' : 'Csak teszt (nem ír semmit)' }}
        </ion-button>
        <ion-button size="small" fill="outline" [disabled]="szinkronFut || (!b.kreta_user && !b.forras_allomany)" (click)="szinkron()">
          <ion-icon slot="start" name="cloud-download-outline"></ion-icon>
          {{ szinkronFut ? 'Fut…' : 'Átemelés most' }}
        </ion-button>
        <ion-button size="small" fill="outline" color="medium" (click)="atvezet(false)">
          <ion-icon slot="start" name="repeat-outline"></ion-icon>Átvezetés újra (letöltés nélkül)
        </ion-button>
      </div>

      <div class="ke-allapot" [class.ke-teszt-baj]="tesztEredmeny && !tesztEredmeny.ok" *ngIf="tesztEredmeny">
        <b>{{ tesztEredmeny.ok ? 'A teszt sikerült' : 'A teszt nem sikerült' }}:</b> {{ tesztEredmeny.szoveg }}
      </div>

      <!-- FUTÁS ÁLLAPOTA. A menet percekig tart; ne csak pörögjön, mondja is, hol tart. -->
      <div class="ke-allapot" *ngIf="allapot?.fut || allapot?.lepes">
        <div><b>{{ allapot?.fut ? 'Folyamatban' : 'Utolsó menet' }}:</b> {{ allapot?.lepes }}</div>
        <div class="ke-szamok" *ngIf="allapot?.lista">
          lista: {{ allapot.lista }} · eltéve: {{ allapot.mentve }} · átvezetve: {{ allapot.atvezetve }}
          · igazolt óra: {{ allapot.orak }}
          <span *ngIf="allapot?.hibak?.length" class="ke-baj"> · hiba: {{ allapot.hibak.length }}</span>
        </div>
        <div class="ke-baj" *ngFor="let h of (allapot?.hibak || [])">{{ h }}</div>
      </div>

      <div class="ke-allapot" *ngIf="b.utolso_futas">
        <b>Utolsó futás:</b> {{ b.utolso_futas | date:'yyyy.MM.dd. HH:mm' }} — {{ b.utolso_eredmeny }}
        <span *ngIf="b.enabled"> · következő: {{ gyakorisagSzoveg }}</span>
      </div>

      <h3 class="ke-cim">
        Átemelt kérelmek
        <ion-button size="small" fill="clear" (click)="kerelmeketBetolt()">
          <ion-icon slot="icon-only" name="refresh-outline"></ion-icon>
        </ion-button>
      </h3>
      <div class="ke-szurok">
        <ion-checkbox [(ngModel)]="csakEeszt" (ionChange)="kerelmeketBetolt()"></ion-checkbox>
        <span (click)="csakEeszt = !csakEeszt; kerelmeketBetolt()">csak EESZT</span>
        <ion-checkbox [(ngModel)]="csakNemAtvezetett" (ionChange)="kerelmeketBetolt()"></ion-checkbox>
        <span (click)="csakNemAtvezetett = !csakNemAtvezetett; kerelmeketBetolt()">csak a még át nem vezetettek</span>
      </div>

      <div class="ke-tabla-burok">
        <table class="ke-tabla" *ngIf="kerelmek.length">
          <thead>
            <tr>
              <th>Tanuló</th><th>Osztály</th><th>Időszak</th><th>Típus</th>
              <th>Döntés</th><th>Átvezetés</th><th>Ügyiratszám</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let k of kerelmek">
              <td>{{ k.tanulo_nev }}<ion-chip *ngIf="k.is_eeszt" class="ke-chip">EESZT</ion-chip></td>
              <td>{{ k.osztaly }}</td>
              <td class="ke-datum">{{ k.kezdet | date:'yyyy.MM.dd.' }}–{{ k.vege | date:'MM.dd.' }}</td>
              <td>{{ k.tipus_nev }}</td>
              <td>
                <span [class.ke-jo]="k.dontes === 'ELFOGADVA'" [class.ke-baj]="k.dontes === 'ELUTASITVA'">
                  {{ k.dontes || k.statusz || '—' }}
                </span>
              </td>
              <td>
                <span *ngIf="k.atvezetve" class="ke-jo">{{ k.atvezetett_orak }} óra</span>
                <span *ngIf="!k.atvezetve" class="ke-var" [title]="k.atvezetes_uzenet">még nem</span>
              </td>
              <td class="ke-datum">{{ k.ugyiratszam }}</td>
            </tr>
          </tbody>
        </table>
        <div class="ke-ures" *ngIf="!kerelmekFut && !kerelmek.length">
          Még nincs átemelt kérelem. Az „Átemelés most" gombbal indítható az első lekérés.
        </div>
      </div>
    </ng-container>
  </ion-card-content>
</ion-card>
